import "twin.macro";

import { Tab, TabProps, Tabs } from "@mui/material";

type Option<T> = {
  title: string;
  value: T;
};

const ToggleButtons = <T,>({
  options,
  onChange,
  value,
  className,
  tabProps,
}: {
  options: Option<T>[];
  onChange: (value: T) => void;
  value: T;
  className?: string;
  tabProps?: TabProps;
}) => {
  return (
    <Tabs
      value={value}
      onChange={(_, value) => onChange(value)}
      tw="bg-neutral-200 rounded-md shadow-inner h-10 px-1 py-[3px] relative min-h-0"
      slotProps={{
        indicator: {
          className: "bg-white shadow-sm rounded h-full",
        },
        list: {
          className: "z-10 relative h-full",
        },
      }}
      className={className}
    >
      {options.map((option, index) => (
        <Tab
          key={index}
          value={option.value}
          label={option.title}
          tw="flex items-center justify-center px-3 py-0 transition text-filter normal-case font-normal min-h-0"
          disableRipple
          {...tabProps}
        />
      ))}
    </Tabs>
  );
};

export default ToggleButtons;
